import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { BackofficeGetClusterResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

type Query = { key: string }
type Response = DataResponse<z.infer<typeof BackofficeGetClusterResponseDataSchema>>
type OnSuccessFn = (data: Response) => void

const getBackofficeClusterQueryKey = (query: Query) => ["backofficeCluster", query]

type Props = {
  query: Query
  onSuccess?: OnSuccessFn
  enabled?: boolean
}

export const getBackofficeClusterQuery = ({ query, onSuccess, enabled = true }: Props) => {
  return queryOptions({
    queryKey: getBackofficeClusterQueryKey(query),
    queryFn: async () => {
      const { data } = await axios.get<Response>(`/backoffice/clusters/${query.key}`)
      onSuccess?.(data)
      return data.data
    },
    enabled,
  })
}
